<template>
  <div class="design-cockpit-step2">
    <ORingAssistantStepCards
      :cards="cards"
      :hide-info-icon="true"
    />
    <MaterialSelection
      v-model="oringMaterialIds"
      @bookmark-materials="importMaterials"
    />
  </div>
</template>

<script setup lang="ts">
import ORingAssistantStepCards from '../OringAssistantStepCards.vue'
import MaterialSelection from '../OringMaterialSelection.vue'
import useI18nExtended from '~/composables/usei18nExtended'
import {useORingCalculatorStore} from '~/store/oring-calculator'

const i18n = useI18nExtended()

const {
  oringDesignCockpitIsHydraulic,
  oringDesignCockpitIsDynamic
} = storeToRefs(useORingCalculatorStore())

// Selected materials
const {oringMaterialIds, oringBookmarkedMaterialIds} = storeToRefs(useORingCalculatorStore())

// Function to import materials
function importMaterials() {
  oringMaterialIds.value = oringBookmarkedMaterialIds.value
}

const cards = [
  {
    title: i18n.tv('Frontend.Title.Movement', 'ORingConfiguratorImport'),
    description: null,
    model: oringDesignCockpitIsDynamic,
    options: [
      {value: false, label: i18n.tv('Frontend.Application.Static', 'ORingConfiguratorImport'), imgUrl: '/img/oring/cockpit_rod_movement_static.png'},
      {value: true, label: i18n.tv('Frontend.Application.Dynamic', 'ORingConfiguratorImport'), imgUrl: '/img/oring/cockpit_rod_movement_dynamic.png'}
    ]
  },
  {
    title: i18n.tv('Frontend.Title.Medium', 'ORingConfiguratorImport'),
    description: null,
    model: oringDesignCockpitIsHydraulic,
    options: [
      {value: true, label: i18n.tv('Frontend.Application.Hydraulic', 'ORingConfiguratorImport'), imgUrl: '/img/oring/cockpit_media_hydraulic.png'},
      {value: false, label: i18n.tv('Frontend.Application.Pneumatic', 'ORingConfiguratorImport'), imgUrl: '/img/oring/cockpit_media_pneumatic.png'}
    ]
  }
]

function validate() {
  // Add validation logic here if needed
  // For example, check if required fields are filled
  return true
}

defineExpose({validate})
</script>
